import { render, staticRenderFns } from "./UpdatePublicityDialog.vue?vue&type=template&id=5e870265&scoped=true"
import script from "./UpdatePublicityDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePublicityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e870265",
  null
  
)

export default component.exports